import PropTypes from 'prop-types';
import React from 'react';


export default function PillCustom(props:any) {

    const onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onClick) props.onClick(props.value)
    }

    const onDelete = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        if (props.onDelete) props.onDelete(props.value)
    }

    let bgClass         = 'gray'
    let borderClass     = false

    const classes = Classes(
        'ui5-pill-u',
        's-'+props.size,
        bgClass, borderClass,
        props.className
    );

    return (
        <div className={classes} onClick={props.onClick}>
            {props.children}
            {props.onDelete && <div className="i5-close" onClick={onDelete} />}
        </div>
    )


}


// PillCustom.propTypes = {
//     size        : PropTypes.oneOf([26, 22]),
//
//     palette     : PropTypes.oneOf(['project', 'status', 'gray']),
//     color       : PropTypes.number,
//
//     // we use children here
//     // label       : PropTypes.string,
//     // icon        : PropTypes.string,
//
//     // callbacks
//     onClick     : PropTypes.func,
//     onDelete    : PropTypes.func,       // if set adds delete button
//     value       : PropTypes.any,       // this is what being passed when we set on click or on delete !!!
//
//     classes     : PropTypes.any,
//     style       : PropTypes.any,
// }
//
// PillCustom.defaultProps = {
//     size        : 26,
//     palette     : 'gray'
// }
